import { Outlet, createRootRouteWithContext, useParams } from "@tanstack/react-router";
import { OmroepContextProvider } from "../component/contextProviders/OmroepContextProvider";
import { TvChannelOverview } from "../component/tvChannelOverview/tvChannelOverview";

export function RootComponent() {
  const { omroep } = useParams({
    strict: false
  });
  return (
    <OmroepContextProvider omroep={omroep ?? ""}>
      <Outlet />
    </OmroepContextProvider>
  );
}

function notFoundComponent() {
  return <TvChannelOverview notFoundComponent={"Kies een omroep:"} />;
}

export type RootContext = {
  isDevtoolsEnabled?: boolean;
};

export const Route = createRootRouteWithContext<RootContext>()({
  notFoundComponent,
  component: () => <RootComponent />
});
